<template>
  <v-card 
    class="detailed-info"
    width="700"
  >
    <v-row>

      <v-col cols="8">
        <v-row v-for="row in taskInfoRows" :key="row">
          <v-col cols="4" class="remove-space-bottom remove-space-right">
            <span class="title">
              {{row}}: 
            </span>
            
          </v-col>
          <v-col cols="8" class="remove-space-bottom remove-space-left">
            {{ returnTaskInfo(row) }}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-card>
              <div
                class="header"
              >
              Actions
              </div>

              <TaskActions
                :item="job"
                :type="type"
                @toggleAssignmentComp="toggleAssignmentComp"
              />
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card >
              <div
                class="header"
              >
              Status: {{ returnJobState(job.done) }}
              </div>

              <v-container class="center-contents">
                <v-row>
                  <v-col cols="12">
                    <div >
                      <v-progress-circular
                        class="task-progress-icon"
                        :rotate="-90"
                        :value="returnJobProgress(job.done)"
                        :size="50"
                        :color="returnStateColour(job.done)"
                      ></v-progress-circular>
                      <span class="task-progress-count">{{ returnJobProgress(job.done) }} %</span>
                    </div>
                    
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("DetailedInfo")

import moment from "moment"

import TaskActions from './TaskActions';

export default {
  name: 'DetailedInfo',
  components: {
    TaskActions
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },  
  data() {
    return {
      taskInfoRows: [
        'Task',
        'Type',
        'Due Date',
        'Assignee',
        'Performed By',
        'Notes'
      ],
      taskInfo:  {
        task: this.job.name,
        type: '',
        due_date: '',
        assignee: '',
        performed_by: '',
        notes: ''
      }
    }
  },
  computed: {
    type() {
      return this.job.Tasks.length > 0 ? this.job.Tasks[0].task_type : '';
    }
  },
  mounted() {
    this.mapTaskInfo();
  },
  methods:  {
    formateDate(date) {
      return moment(date).format("DD/MM/YYYY")
    },
    returnJobState(count) {
      let state;

      if(this.type == 'device_config' || this.type == 'firmwareupdate') {
        const items = this.job.Tasks[0].context.devices;
        const total = this.job.Tasks[0].context.devices.length;
        const pending = items.filter(item => {
          return item.status_name === "pending";
        });
        logger.info(items, total, pending.length)
        const count = (100 * (total - pending.length) / total);
        
        state = Math.round(count);

      }
      else {
        if (isNaN(count)) return 0;

        state = count;
      }

      return state < 100 ? 'In Progress' : 'Complete';
    },
    returnJobProgress(count) {
      if(this.type == 'device_config' || this.type == 'firmwareupdate') {
        const items = this.job.Tasks[0].context.devices;
        const total = this.job.Tasks[0].context.devices.length;
        const pending = items.filter(item => {
          return item.status_name === "pending";
        });
        const count = (100 * (total - pending.length) / total);
        
        return Math.round(count);

      }
      else {
        if (isNaN(count)) return 0;

        return count;
      }
      
    },  
    mapTaskInfo() {
      if (!this.job || !(this.job.Tasks.length > 0)) return;

      this.taskInfo.task = this.job.Tasks[0].name;
      this.taskInfo.type = this.jobTypeMap(this.job.Tasks[0].task_type);
      this.taskInfo.due_date = this.formateDate(this.job.Tasks[0].due_on);
      this.taskInfo.assignee = this.job.Tasks[0].assigned_to;
      this.taskInfo.performed_by =  this.job.Tasks[0].performed_by;
      this.taskInfo.notes = this.job.Tasks[0].task_description;
    },
    jobTypeMap(type) {
      const map = {
        'firmwareupdate': 'Firmware Update',
        'taskinstall': 'One Time Code',
        'device_config': 'Device Configuration'
      };

      if (Object.hasOwn(map, type)) {
        return map[type];
      }
    },
    returnTaskInfo(row) {
      const formatedRowKey = row.toLowerCase().replace(' ', '_');
      
      if (Object.hasOwn(this.taskInfo, formatedRowKey)) {
        return this.taskInfo[formatedRowKey];
      }
    },
    returnStateColour(count) {
      if(this.type == 'device_config' || this.type == 'firmwareupdate') {
        const items = this.job.Tasks[0].context.devices;
        const total = this.job.Tasks[0].context.devices.length;
        const pending = items.filter(item => {
          return item.status === "pending";
        });
        logger.info(items, total, pending.length)
        const count = (100 * (total - pending.length) / total);
        
        return this.statusColourOptions(count);

      }
      else {
        if (isNaN(count)) return 0;

        return this.statusColourOptions(count);
      }
    },
    statusColourOptions(progress) {
      if (!progress) return 'grey';

      if (progress < 100) {
          return 'orange';
      }
      else {
          return 'green';
      }
    },
    toggleAssignmentComp(task) {
      this.$emit('toggleAssignmentComp', task);
    }
  }
}
</script>

<style lang="scss">
  .detailed-info {
    margin: 1.5em;
    padding: 1em;
    .header {
      background: #25335a;
      color: white;
      text-align: center;
      padding: 0.25em 0;
    }
    .title {
      color: #0f74bb;
      padding-left: 1em;
      font-size: 0.875rem !important;
    }
    .remove-space-bottom {
      padding-bottom: 0;
    }
    .remove-space-left {
      padding-left: 0;
    }
    .remove-space-right {
      padding-right: 0;
    }
    .center-contents {
      text-align: center;
    }

    .task-progress-icon {
      position: relative;
    }
    .task-progress-count {
      position: absolute;
      left: 50%;
      top: 54%;
      transform: translate(-50%, 0);
    }
  }

  .no-padding {
    padding: 0;
  }
</style>